import SideMenu from '@/containers/side-menu/SideMenu.vue'
import ReportParkedNotified from '@/pages/report-parked-notified/ReportParkedNotified'

export default {
  path: '/report-parked-notified',
  name: 'ReportParkedNotified',
  components: {
    mainContent: ReportParkedNotified,
    mainMenu: SideMenu
  },
  meta: {
    role: {
      sectorId: 'report-parked-notified'
    },
    breadcrumb: {
      title: 'Relatório de Veículos Ativamente Notificado',
      paths: [
        { title: 'Relatórios' },
        { title: 'Veículos Ativos Notificados' }
      ]
    }
  }
}